/*
 * Copyright (c) 2025, Gather
 * https://gather.life
 */

export const numberFormatter = (value: string | number, places = 0, locale = 'en-US'): string => {
  const number = typeof value === 'string' ? parseFloat(value) : value;

  return Number(number).toLocaleString(locale, {
    minimumFractionDigits: places,
    maximumFractionDigits: places,
  });
};
